import {ChangeDetectionStrategy, Component, ElementRef, inject, Input, OnChanges, ViewChild} from '@angular/core';
import {BaseComponent, FileService, ImagePreviewComponent, ImagePreviewPicture, YouTube, YoutubeVideoService} from 'compob2b-libs';

@Component({
  selector: 'app-photo-slider',
  templateUrl: './photo-slider.component.html',
  styleUrls: ['./photo-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PhotoSliderComponent extends BaseComponent implements OnChanges {
  @Input() title: string;
  @Input() pictures: string[];
  @Input() videos: YouTube[];
  @Input() itemsPerView: number = 1;

  @ViewChild('sliderTrack', {static: true}) sliderTrack: ElementRef;
  @ViewChild(ImagePreviewComponent) preview: ImagePreviewComponent;

  photos: ImagePreviewPicture[] = [];
  currentGroupIndex = 0;
  maxGroupIndex = 0;
  currentSlideIndex = 0;

  youtubeVideoService = inject(YoutubeVideoService);
  fileService = inject(FileService);

  ngOnChanges(): void {
    this.photos = [];
    this.currentGroupIndex = 0;
    this.currentSlideIndex = 0;

    this.pictures?.forEach(picture => {
      this.photos.push({
        src: this.fileService.getImageSrc(picture, 800),
        original: this.fileService.getImageSrc(picture),
      });
    });

    this.videos?.forEach(video => {
      this.photos.push({
        src: this.youtubeVideoService.getSrc(video),
        videoCode: video.code
      });
    });

    if (this.photos.length === 0) {
      this.photos.push({src: this.noPhotoSrc});
    }

    this.calculateMaxGroupIndex();
  }

  calculateMaxGroupIndex(): void {
    this.maxGroupIndex = Math.max(0, Math.ceil(this.photos.length / this.itemsPerView) - 1);
  }

  nextGroup(): void {
    if (this.currentGroupIndex < this.maxGroupIndex) {
      this.currentGroupIndex++;
      this.currentSlideIndex = this.currentGroupIndex * this.itemsPerView;
    } else {
      this.currentGroupIndex = 0;
      this.currentSlideIndex = 0;
    }
  }

  prevGroup(): void {
    if (this.currentGroupIndex > 0) {
      this.currentGroupIndex--;
      this.currentSlideIndex = this.currentGroupIndex * this.itemsPerView;
    }
  }

  isThumbnailActive(index: number): boolean {
    return index === this.currentSlideIndex;
  }

  open(index: number): void {
    this.preview.show(index, this.photos);
  }
}
